module.exports = __webpack_public_path__ + "h5/img/bs_21.e99119d6.jpg";